(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyDeleteController',CareTeamSpecialtyDeleteController);

    CareTeamSpecialtyDeleteController.$inject = ['$uibModalInstance', 'entity', 'CareTeamSpecialty'];

    function CareTeamSpecialtyDeleteController($uibModalInstance, entity, CareTeamSpecialty) {
        var vm = this;

        vm.careTeamSpecialty = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CareTeamSpecialty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
